<template>
  <div class="service">
    <div v-html="agree"></div>
  </div>
</template>

<script>
import { getAgreement } from '../api/index'
import i18n from '../locales/i18n'
import { applyLocaleFromRoute } from '../utils/locale'

export default {
  name: 'police',
  data() {
    return {
      agree: null
    }
  },
  created() {
    this.syncLang()
    this.getAgree()
  },
  watch: {
    '$route.query.lang'() {
      this.syncLang()
      this.getAgree()
    }
  },
  methods: {
    syncLang() {
      applyLocaleFromRoute(this.$route, i18n)
    },
    getAgree() {
      getAgreement(2).then((res) => {
        this.agree = res.content
      })
    }
  }
}
</script>

<style scoped lang="less">
.service {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  div {
    margin-top: 10%;
    margin-bottom: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/police.vue